// index.js
export const defaultLocale = 'fi-FI';

export const languages = {
  en: { short: 'en-GB', file: 'en', translation: 'English' },
  fi: { short: 'fi-FI', file: 'fi', translation: 'Suomi' },
  sv: { short: 'sv-SE', file: 'sv', translation: 'Svenska' },
};

export const supportedLanguages = ['en-GB', 'fi-Fi', 'sv-SE'];
